<template>
    <header class="header">
            <div class="logo-container">
                <a href="" class="logo">
                    <img src="/assets/images/logo-cuatrotorres-v2.png" width="170" height="50" alt="CuatroTorres" />
                </a>
                <div class="visible-xs toggle-sidebar-left" data-toggle-class="sidebar-left-opened" data-target="html" data-fire-event="sidebar-left-opened">
                    <i class="fa fa-bars" aria-label="Toggle sidebar"></i>
                </div>
            </div>
        
            <!-- start: search & user box -->
            <div class="header-right">
        
                <span class="separator"></span>
        
        
                <div id="userbox" class="userbox" v-if="$auth.isAuthenticated">
                    <a href="#" data-toggle="dropdown">
                        <figure class="profile-picture">
                            <img src="/assets/images/!logged-user.jpg" class="img-circle" data-lock-picture="/assets/images/!logged-user.jpg" />
                        </figure>
                        <div class="profile-info" :data-lock-name="$auth.user.name" :data-lock-email="$auth.user.email">
                            <span class="name">{{ $auth.user.name }}</span>
                            <span class="role">Cliente</span>
                        </div>
        
                        <i class="fa custom-caret"></i>
                    </a>
        
                    <div class="dropdown-menu">
                        <ul class="list-unstyled">
                            <li class="divider"></li>
                            <li>
                                <a role="menuitem" tabindex="-1" href=""><i class="fa fa-user"></i> Mi Cuenta</a>
                            </li>
                            <li>
                            <a role="menuitem" tabindex="-1" @click="logout"><i class="fa fa-power-off"></i> Cerrar Sesión</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>            
            <!-- end: search & user box -->
        </header>
</template>

<script>
    export default {
        name: 'Header',        
        data : function() {
            return {}
        },        
        methods: {
            // Log the user in
            login() {
                this.$auth.loginWithRedirect();
                },
            // Log the user out
            logout() {
                this.$auth.logout({
                    returnTo: window.location.origin
                });
            }
        }
    }
</script>